export default "__VITE_ASSET__CsMy$fip__"